import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { environment } from 'src/environments/environment';
import { Video } from 'src/app/interfaces/video/video';
import { ToastService } from 'src/app/services/toast.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { VideoService } from 'src/app/services/video.service';
import { VgApiService } from '@videogular/ngx-videogular/core';
import { Subscription } from 'rxjs';
import { LangService } from 'src/app/services/lang.service';
import { VideoSubtitle } from 'src/app/interfaces/video/video-subtitle';

declare var kWidget: any;

const SUBTITLE_LABELS: { [language: string]: string } = {
  nl: 'Nederlands',
  en: 'English',
  es: 'Español',
  pt: 'Português',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano',
};

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
})
export class VideoPlayerComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @Output() watched: EventEmitter<Video> = new EventEmitter();
  @Output() sendSeconds: EventEmitter<any> = new EventEmitter();
  @Input() video: Video | undefined;
  @Input() isMicroclip: boolean | undefined = false;
  @Input() getTime: any | undefined = {};
  @Input() vgControl: boolean = true;
  @Input() autoPlay: boolean = false;
  API: VgApiService | undefined;

  loading = true;
  safeUrl: SafeResourceUrl = '';
  subtitles: VideoSubtitle[] = [];
  uiLanguage: string | null = null;
  private langSubscription: Subscription | undefined;
  kdp: any | undefined;
  alreadyWatched = false;
  public timeFormat: 'mm:ss' | 'hh:mm:ss' = 'mm:ss';

  constructor(
    private toastService: ToastService,
    public sanitizer: DomSanitizer,
    private videoService: VideoService,
    private lang: LangService
  ) {
    this.langSubscription = this.lang.language.subscribe((lang) => {
      this.uiLanguage = lang;
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.getTime.start_time) {
      this.selectedInterval.start = this.getTime.start_time / 1000;
      this.selectedInterval.end = this.getTime.end_time / 1000;
    }
  }

  ngAfterViewInit(): void {
    let flashvars: any = { autoPlay: false };

    if (this.video?.source?.enable_watermark) {
      flashvars = {
        autoPlay: false,
        watermark: {
          plugin: true,
          img: '/assets/img/logos/mllogo-md.png',
          href: '',
          cssClass: this.video.source.watermark_position
            ? this.video.source.watermark_position.replace(
                /-([a-z])/g,
                function (g) {
                  return g[1].toUpperCase();
                }
              )
            : 'topRight',
        },
      };
    }

    // let that = this;
    // let interval = setInterval(() => {
    //   if (kWidget) {
    //     kWidget.embed({
    //       targetId: 'kaltura_player_' + this.video?.source?.external_id,
    //       wid: '_' + environment.vixyPId,
    //       uiconf_id: environment.vixyPlayerId,
    //       flashvars: flashvars,
    //       cache_st: this.video?.source?.external_id,
    //       entry_id: this.video?.source?.external_id,
    //       readyCallback: function readyCallback(playerID: any) {
    //         that.kdp = document.getElementById(playerID);

    //         that.kdp.kBind('monitorEvent', () => {
    //           that.updateTime(
    //             that.kdp.evaluate('{video.player.currentTime}'),
    //             that.kdp.evaluate('{duration}')
    //           );
    //         });
    //       },
    //     });
    //     clearInterval(interval);
    //   }
    // }, 500);

    this.loading = false;
  }

  ngOnInit(): void {
    if (this.video?.source?.video_provider == 'spaces') {
      let video = this.video?.source?.video_spaces_original;
      // Los subtítulos se cargan antes que la URL: vg-track-selector solo lee
      // los <track> cuando el player está listo (y el player depende de safeUrl)
      Promise.all([
        this.videoService.getVideoURL(video),
        this.video?.id ? this.videoService.getSubtitles(this.video.id) : Promise.resolve([]),
      ]).then(([resp, subtitles]) => {
        this.subtitles = this.sortSubtitles(subtitles);
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(resp.url);
        console.log('video',this.video)
        console.log('thumb_url',this.video?.thumb_url)

      });
    }
  }

  subtitleLabel(language: string): string {
    return SUBTITLE_LABELS[language] ?? language.toUpperCase();
  }

  // Subtítulo activo por defecto: el del idioma de la interfaz, si existe
  isDefaultSubtitle(language: string): boolean {
    return language === this.uiLanguage;
  }

  private sortSubtitles(subtitles: VideoSubtitle[]): VideoSubtitle[] {
    return [...subtitles].sort((a, b) =>
      this.subtitleLabel(a.language).localeCompare(this.subtitleLabel(b.language))
    );
  }
  isRecent(createdAt: string | Date | undefined): boolean {
    if (!createdAt) return false;
    if (!this.video?.source?.exist) return false;
    if (this.video?.source?.status!=2) return true; //si aun no esta procesado devuelvo false para que muestre el upload
    return false;
    // const created = new Date(createdAt).getTime();
    // const now = new Date().getTime();
  
    // // Diferencia en milisegundos
    // const diff = now - created;
  
    // // 1 hora = 3600000 ms
    // console.log('diff',diff)
    // return diff <= 3600000;
  
  }
  
  updateTime(currentTime: any, duration: any) {
    currentTime = (currentTime * 1000).toFixed(0);
    duration = (duration * 1000).toFixed(0);

    if (duration) {
      var percentage = Math.trunc((currentTime * 100) / duration);

      if (percentage >= 96 && !this.alreadyWatched) {
        this.watched.emit(this.video);
        this.alreadyWatched = true;
      }
    }
  }

  public selectedInterval: any = { start: 0, end: 0 };
  @ViewChild('media', { static: false }) mediaElem: any;

  setIntervalPoint(point: 'start' | 'end'): void {
    // 1. Obtener el tiempo actual
    const currentTime = this.API?.getDefaultMedia().currentTime;

    // 2. Construir tiempos temporales para validar
    const tempStart =
      point === 'start' ? currentTime : this.selectedInterval.start;
    const tempEnd = point === 'end' ? currentTime : this.selectedInterval.end;

    if (tempStart && tempEnd) {
      if (tempStart > tempEnd) {
        this.toastService.showError(
          'Start time cannot be greater than end time.'
        );
        return;
      } else if (tempEnd < tempStart) {
        this.toastService.showError('End time cannot be less than start time.');
        return;
      }
    }

    this.selectedInterval.start = tempStart;
    this.selectedInterval.end = tempEnd;

    this.updateIntervalDisplay();
  }

  updateIntervalDisplay() {
    this.sendSeconds.emit(this.selectedInterval);
  }
  currentSeconds = 0;
  totalSeconds = 0;
  private timeUpdateSub?: Subscription;

  onPlayerReady(api: VgApiService) {
    this.API = api;

    // Nos suscribimos al evento timeUpdate del media por defecto
    this.timeUpdateSub =
      this.API.getDefaultMedia().subscriptions.timeUpdate.subscribe(
        (event: { currentTime: number }) => {
          this.currentSeconds = event.currentTime;
        }
      );

    // Nos suscribimos al evento loadedMetadata para obtener la duración
    this.API.getDefaultMedia().subscriptions.loadedMetadata.subscribe(() => {
      this.totalSeconds = this.API?.getDefaultMedia()?.duration || 0;
      if ( this.totalSeconds >= 3600) { // 3600 segundos = 1 hora
        this.timeFormat = 'hh:mm:ss';
      } else {
        this.timeFormat = 'mm:ss';
      }
    });

   

  }

  ngOnDestroy() {
    this.timeUpdateSub?.unsubscribe();
    this.langSubscription?.unsubscribe();
  }

  formatTime(seconds: number): string {
    if (!seconds || isNaN(seconds) || seconds < 0) return '00:00';
    
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
}
